import { createSelector } from 'reselect';
import { OrionState } from '../../../../createReducer';

export const selectCloudProductsNames = createSelector(
  (state: OrionState) => state.cloudProducts.cloudProducts,
  (state: OrionState) => state.cloudProducts.cloudProductsIds,
  (products, ids) => ids.map((id) => products[id]).map((product) => product.name)
);
